import { createContext } from "react";

const UserContext = createContext({
    loggedInUser : "Sudheesh"
})

export default UserContext;